package com.veldekar.pages.log

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.veldekar.components.layouts.SessionPageLayout
import com.veldekar.components.logs.Log_2026_03_07_Day_1
import com.veldekar.components.logs.Log_2026_03_07_Day_2
import com.veldekar.components.logs.Log_2026_03_07_Day_3
import com.veldekar.components.widgets.SessionDayHeader
import com.veldekar.components.widgets.SessionMediaItem
import kotlinx.datetime.LocalDate

@Page(routeOverride = "/2026-03-07")
@Composable
public fun Log_2026_03_07(ctx: PageContext) {
    SessionPageLayout(
        ctx = ctx,
        title = "Umbraxus",
        ogTitle = "Umbraxus",
        date = LocalDate(2_026, 3, 7),
        aiHint = "Image, title, and description are a joke about the dragon's name 'Umbraxus' sounds like a cleaning product.",
        ogDescription = "From the toughest grease to the deepest stains, Umbraxus handles the hard work so you don't have to.",
        ogImage = "images/umbraxusMop_preview.webp",
        ogImageWidth = 1_200,
        ogImageHeight = 630,
        ogImageAlt = "A hand-drawn illustration of a green dragon wearing overalls and mopping a floor next to a caution sign. This is a reference to the name \"Umbraxus,\" which was supposed to strike fear into the hearts of the heroes but sounded more like an industrial cleaning product.",
    ) {
        SessionDayHeader(dayId = "shimmer-13", dateString = "Shimmer 13")
        Log_2026_03_07_Day_1()
        SessionDayHeader(dayId = "shimmer-14", dateString = "Shimmer 14")
        Log_2026_03_07_Day_2()
        SessionDayHeader(dayId = "shimmer-15", dateString = "Shimmer 15")
        Log_2026_03_07_Day_3()
        SessionMediaItem(
            image = "images/umbraxusMop.webp",
            linkImage = "images/umbraxusMop.webp",
            description = "A hand-drawn illustration of a green dragon wearing overalls and mopping a floor next to a caution sign. This is a reference to the name \"Umbraxus,\" which was supposed to strike fear into the hearts of the heroes but sounded more like an industrial cleaning product.",
            width = 3_995,
            height = 2_900,
        )
    }
}
